// next/link → react-router shim for the copied ArcDisk components.
// They call `<Link href=...>`; react-router wants `to`. Everything else passes
// through, so the persistent Arc shell survives the navigation.
import type { ComponentProps } from 'react'
import { Link as RouterLink } from 'react-router-dom'

type Props = Omit<ComponentProps<typeof RouterLink>, 'to'> & { href: string }

export default function Link({ href, ...rest }: Props) {
  return <RouterLink to={href} {...rest} />
}
